<template>
  <v-container fluid>
    <v-card :height="height" class="overflow-y-auto" :width="width">
      <v-system-bar v-if="!!title">{{title}}</v-system-bar>
      <v-card-text class="px-3">
      <v-text-field
          append-outer-icon="mdi-plus-circle-outline"
          v-model="newMatch"
          outlined
          dense
          hide-details
          @click:append-outer="addNewMatch()"
      >
      </v-text-field>
      <v-chip
        v-for="(item, index) of dataList"
        :key="index"
        close
        outlined
        class="mr-3 mt-3"
        @click:close="onClear(index)"
      >
        {{item}}
      </v-chip>
        </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import BaseFieldString from "@/components/Base/BaseFieldString";
import BaseFieldNumber from "@/components/Base/BaseFieldNumber";

export default {
  name: 'CommonChipCombobox',
  props: {
    title: {default: null},
    height: {default: '100%'},
    width: {default: '30%'},
    value: {
      type: [Array], default: function () {
        return []
      }
    },
    number: {type: [Boolean], default: false},
    addText: {type: [String], default: null},
    small: {default: false}
  },

  components: {
    BaseFieldString,
  },

  computed: {},

  watch: {
    value: {
      handler(newValue, oldValue) {
        if (newValue !== oldValue)
        this.dataList = structuredClone(newValue)
      },
      deep: false
    },
  },

  methods: {
    addNewMatch() {
      if (this.newMatch != null) {
        this.dataList.push(this.newMatch)
        this.$emit('input', this.dataList)
        this.newMatch = null
      }
    },
    onClear(index) {
      // console.log('onClear', index)
      this.dataList.splice(index, 1)
      this.$emit('input', this.dataList)
    },
  },

  mounted() {
    this.dataList = structuredClone(this.value)
  },

  data() {
    return {
      dataList: [],
      newMatch: null,
    }
  },
}

</script>


<style scoped lang="scss">
</style>